(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cellini-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCCT() {
    var drawer = document.querySelector('[data-cct-drawer]');
    if (drawer) {
      document.querySelectorAll('[data-cct-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); drawer.hidden = false; drawer.setAttribute('aria-hidden','false'); document.body.classList.add('cct-drawer-open'); }); });
      drawer.querySelectorAll('[data-cct-close]').forEach(function (b) { b.addEventListener('click', function () { drawer.hidden = true; drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('cct-drawer-open'); }); });
    }
    document.querySelectorAll('[data-cct-price-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault();
        var gte = form.querySelector('[name="filter.v.price.gte"]'); var lte = form.querySelector('[name="filter.v.price.lte"]');
        var params = new URLSearchParams(window.location.search);
        params.delete('filter.v.price.gte'); params.delete('filter.v.price.lte');
        if (gte && gte.value.trim() !== '') params.set('filter.v.price.gte', gte.value.trim());
        if (lte && lte.value.trim() !== '') params.set('filter.v.price.lte', lte.value.trim());
        var qs = params.toString(); window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    });
    document.querySelectorAll('[data-cct-slider]').forEach(function (s) {
      var rmin = s.querySelector('[data-cct-rmin]'), rmax = s.querySelector('[data-cct-rmax]'), fill = s.querySelector('[data-cct-fill]');
      var form = s.closest('form'); var gte = form && form.querySelector('[data-cct-gte]'); var lte = form && form.querySelector('[data-cct-lte]');
      var pmax = parseFloat(s.getAttribute('data-cct-pmax')) || 100;
      function paint(){ var a=parseFloat(rmin.value)||0, b=parseFloat(rmax.value); if(isNaN(b))b=pmax; var lo=Math.min(a,b), hi=Math.max(a,b); fill.style.left=(lo/pmax*100)+'%'; fill.style.width=((hi-lo)/pmax*100)+'%'; }
      function fromSlider(){ var a=parseFloat(rmin.value)||0, b=parseFloat(rmax.value); if(isNaN(b))b=pmax; if(gte) gte.value = a<=0 ? '' : a; if(lte) lte.value = b>=pmax ? '' : b; paint(); }
      function fromInputs(){ var a=parseFloat(gte&&gte.value), b=parseFloat(lte&&lte.value); rmin.value = isNaN(a)?0:Math.max(0,Math.min(a,pmax)); rmax.value = isNaN(b)?pmax:Math.max(0,Math.min(b,pmax)); paint(); }
      rmin.addEventListener('input', function(){ if(parseFloat(rmin.value) > parseFloat(rmax.value)) rmin.value = rmax.value; fromSlider(); });
      rmax.addEventListener('input', function(){ if(parseFloat(rmax.value) < parseFloat(rmin.value)) rmax.value = rmin.value; fromSlider(); });
      if(gte) gte.addEventListener('change', fromInputs);
      if(lte) lte.addEventListener('change', fromInputs);
      paint();
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initCCT); } else { initCCT(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellini-food-story"] && !Shopify.designMode) return;
  try {
    
(function() {
  // FAQ accordion
  var items = document.querySelectorAll('.cfs-faq__item');
  items.forEach(function(item) {
    var btn = item.querySelector('.cfs-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      // close all
      items.forEach(function(el) {
        el.classList.remove('is-open');
        var b = el.querySelector('.cfs-faq__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Reveal animation (opacity only, no transform)
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cfs-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.cfs-anim').forEach(function(el) { obs.observe(el); });

    // Tile gold line trigger (use same observer)
    var tileObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cfs-visible');
          tileObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    document.querySelectorAll('.cfs-tile').forEach(function(el) { tileObs.observe(el); });
  } else {
    // Reduced motion: show everything immediately
    document.querySelectorAll('.cfs-anim, .cfs-tile').forEach(function(el) {
      el.classList.add('cfs-visible');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellini-home-service-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cellini-service-reviews')) {
    customElements.define('cellini-service-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.__csrInit) return;
        this.__csrInit = true;
        var root = this;
        var tsid = root.dataset.tsid;
        if (!tsid) return;
        var BASE = 'https://api.trustedshops.com/rest/public/v2/shops/' + tsid;
        var MONTHS = ['Januar','Februar','Maerz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

        // eTrusted Service-Review-Feed (secret-frei, gleiche Quelle wie das Service-Bewertungs-Karussell-Widget).
        // Liefert kuratierte Service-Reviews MIT Text (nicht auf 10 gekappt wie die alte v2-API).
        var widget = root.dataset.widget || '';
        var FEED = widget ? 'https://integrations.etrusted.com/feeds/review-carousel-service/v1/widgets/' + widget + '/feed.json' : '';

        function stars(rating) {
          var html = '';
          for (var i = 1; i <= 5; i++) {
            if (rating >= i) { html += '<span class="csr-star csr-star--full">&#9733;</span>'; }
            else if (rating >= i - 0.5) { html += '<span class="csr-star csr-star--half">&#9733;</span>'; }
            else { html += '<span class="csr-star">&#9733;</span>'; }
          }
          return html;
        }
        function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
        function fmtNum(n) { return Number(n).toLocaleString('de-DE'); }
        function fmtMark(m) { return Number(m).toFixed(2).replace('.', ','); }
        function fmtDate(s) { if (!s) return ''; var d = new Date(s); if (isNaN(d)) return ''; return d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
        function cardHTML(r) {
          return '<figure class="csr__card">' +
            '<div class="csr__card-stars">' + stars(Number(r.mark)) + '</div>' +
            '<blockquote class="csr__card-text">' + esc((r.comment || '').trim()) + '</blockquote>' +
            '<figcaption class="csr__card-date">' + fmtDate(r.creationDate) + '</figcaption>' +
          '</figure>';
        }

        // Ableitung der Textbewertung aus dem Score (TS-Schwellen: EXCELLENT >=4.5, VERY GOOD >=3.5, GOOD >=2.5, FAIR >=1.5)
        function descForMark(m) {
          if (m >= 4.5) return 'Hervorragend';
          if (m >= 3.5) return 'Sehr gut';
          if (m >= 2.5) return 'Gut';
          if (m >= 1.5) return 'Befriedigend';
          return 'Mangelhaft';
        }

        // Badge-Feed (eTrusted): identische Quelle wie das schwebende Trustbadge → gleicher Wert (z. B. 4,89)
        var CONFIG = 'https://widgets.trustedshops.com/js/' + tsid + '.js';

        Promise.all([
          fetch(CONFIG).then(function (r) { return r.text(); }).catch(function () { return ''; }),
          fetch(BASE + '/quality/reviews.json').then(function (r) { return r.json(); }).catch(function () { return null; }),
          fetch(BASE + '/reviews.json').then(function (r) { return r.json(); }).catch(function () { return null; }),
          FEED ? fetch(FEED).then(function (r) { return r.json(); }).catch(function () { return []; }) : Promise.resolve([])
        ]).then(function (res) {
          var cfgTxt = res[0] || '';
          var q = (res[1] && res[1].response) ? res[1].response.data.shop.qualityIndicators.reviewIndicator : null;
          var revs = (res[2] && res[2].response) ? (res[2].response.data.shop.reviews || []) : [];
          var feed = Array.isArray(res[3]) ? res[3] : [];

          // ── Aggregat (unveraendert): primaer Trustbadge-Werte aus dem eTrusted-Config-JS; Fallback v2-Quality-API ──
          var mark = q ? q.overallMark : null;
          var count = q ? q.totalReviewCount : null;
          var mMark = cfgTxt.match(/averageRating"?\s*:\s*([\d.]+)/);
          var mCount = cfgTxt.match(/overallRatingCount"?\s*:\s*(\d+)/);
          if (mMark) { mark = parseFloat(mMark[1]); }
          if (mCount) { count = parseInt(mCount[1], 10); }

          var profile = root.dataset.profile || '';
          var eyebrow = root.dataset.eyebrow || 'KUNDENSTIMMEN';
          if (mark != null) {
            root.querySelector('.csr__agg-data').innerHTML =
              '<span class="csr__eyebrow">' + esc(eyebrow) + '</span>' +
              '<div><span class="csr__score">' + fmtMark(mark) + '</span><span class="csr__score-max"> / 5</span></div>' +
              '<div class="csr__stars">' + stars(mark) + '</div>' +
              '<div class="csr__desc">' + descForMark(mark) + '</div>' +
              (count != null ? '<div class="csr__count">' + fmtNum(count) + ' geprüfte Bewertungen</div>' : '') +
              (profile ? '<a class="csr__attr" href="' + esc(profile) + '" target="_blank" rel="noopener">Geprüft von Trusted Shops</a>' : '');
          }

          // ── Karten: primaer eTrusted-Service-Feed (viele Reviews MIT Text), Fallback alte v2-Reviews ──
          var picked = feed
            .filter(function (r) { return (r.comment || '').trim().length >= 8 && Number(r.rating) >= 4; })
            .map(function (r) { return { mark: r.rating, comment: r.comment, creationDate: r.date }; });

          if (picked.length < 3) {
            revs.filter(function (r) { return (r.comment || '').trim().length >= 8 && Number(r.mark) >= 4; })
                .forEach(function (r) { picked.push({ mark: r.mark, comment: r.comment, creationDate: r.creationDate }); });
          }
          picked = picked.slice(0, 12);
          if (!picked.length) { root.style.display = 'none'; return; }

          var groupHTML = picked.map(cardHTML).join('');
          var track = root.querySelector('.csr__track');
          track.innerHTML =
            '<div class="csr__group">' + groupHTML + '</div>' +
            '<div class="csr__group" aria-hidden="true">' + groupHTML + '</div>';

          // Bei wenigen Karten kein Endlos-Scroll (wirkt sonst leer), sonst Marquee mit Tempo nach Anzahl.
          var marquee = root.querySelector('.csr__marquee');
          if (picked.length < 4) {
            marquee.classList.add('csr__marquee--static');
          } else {
            track.style.setProperty('--csr-dur', (picked.length * 5) + 's');
          }

          root.classList.remove('is-loading');
        }).catch(function () { root.style.display = 'none'; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellini-kaffee-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  const scope = document.querySelector('.cellini-pdp');
  if (!scope) return;

  /* ── Versand-Status (12-Uhr-Cutoff deaktiviert — CS-83): Mo–Do 24 Stunden, Fr–So nächster Werktag ── */
  (function(){
    var el = scope.querySelector('#heroShipStatus');
    if (!el) return;
    function parts(){ var f=new Intl.DateTimeFormat('en-US',{timeZone:'Europe/Berlin',weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}); var m={}; f.formatToParts(new Date()).forEach(function(p){m[p.type]=p.value;}); var wd={Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6,Sun:7}; var h=parseInt(m.hour,10); if(h===24)h=0; return {weekday:wd[m.weekday],hour:h,minute:parseInt(m.minute,10),second:parseInt(m.second,10)}; }
    function p2(n){return (n<10?'0':'')+n;}
    function status(){ var p=parts(); if(p.weekday>=1&&p.weekday<=4){return 'Versand in 24 Stunden';} return 'Versand am nächsten Werktag'; }
    function tick(){ el.textContent = status(); }
    tick();
  })();

  /* Robustes In-Page-Anchor-Scrolling: nativer smooth-Scroll bricht ueber grosse
     Distanz + Lazy-Reveal-Content ab -> gezielter Sprung mit Nachkorrektur. */
  scope.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href'), el;
      try { el = document.querySelector(id); } catch(_) { return; }
      if (!el) return;
      e.preventDefault();
      try { history.pushState(null, '', id); } catch(_) {}
      var root = document.documentElement, prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      function go(){ window.scrollBy(0, el.getBoundingClientRect().top - 120); }
      go(); setTimeout(go, 120); setTimeout(go, 320);
      setTimeout(function(){ go(); root.style.scrollBehavior = prev; }, 620);
    });
  });

  /* ── STICKY ATC ──────────────────────────────────── */
  const heroSection = scope.querySelector('.hero');
  const stickyAtc = scope.querySelector('#stickyAtc');
  if (heroSection && stickyAtc) {
    new IntersectionObserver(entries => {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(heroSection);
  }

  /* ── VARIANT + SUBSCRIBE ─────────────────────────── */
  const priceEl = scope.querySelector('#heroPrice');
  const priceNoteEl = scope.querySelector('#heroPriceNote');
  const stickyPriceEl = scope.querySelector('.sticky-atc-price');
  const atcBtn = scope.querySelector('#heroAtcForm .hero-atc');
  const heroNotify = scope.querySelector('#heroNotify');
  const stickyBtn = scope.querySelector('.sticky-atc-btn');
  const skuEl = scope.querySelector('#heroSku');
  const b2bEl = scope.querySelector('#heroB2b');
  const heroWasEl = scope.querySelector('#heroPriceWas');
  const heroBadgeEl = scope.querySelector('#heroSaveBadge');
  const cbRetter = scope.hasAttribute('data-retter');
  const stickyWasEl = scope.querySelector('#stickyWas');
  const stickySaveEl = scope.querySelector('#stickySave');
  let cpVariants = [];
  const vjson = scope.querySelector('#cpdpVariants');
  if (vjson) { try { cpVariants = JSON.parse(vjson.textContent); } catch(e){} }
  function cpMoney(cents){ return '€' + (cents/100).toFixed(2).replace('.', ','); }
  let cpSel = null;
  const activePill = scope.querySelector('.hero-var-opt.active');
  if (activePill) cpSel = cpVariants.find(v => String(v.id) === activePill.dataset.vid);
  if (!cpSel) { const idIn = scope.querySelector('form[action="/cart/add"] input[name="id"]'); if (idIn) cpSel = cpVariants.find(v => String(v.id) === idIn.value); }
  if (!cpSel && cpVariants.length) cpSel = cpVariants[0];
  const proTasseEl = scope.querySelector('#heroProTasse');
  const statProTasseEl = scope.querySelector('#statProTasse');
  const subOpts = scope.querySelectorAll('.hero-sub-opt');
  function cpIsAbo(){ const a = scope.querySelector('.hero-sub-opt.active'); return a ? a.dataset.sub === 'abo' : false; }
  function cpRender(){
    if (!cpSel) return;
    var _avail = cpSel.available !== false;
    if (atcBtn) { atcBtn.hidden = !_avail; atcBtn.disabled = !_avail; if (_avail) atcBtn.textContent = 'In den Warenkorb'; }
    if (heroNotify) { heroNotify.hidden = _avail; heroNotify.setAttribute('data-notify-variant', cpSel.id); }
    if (stickyBtn) {
      stickyBtn.disabled = false;
      stickyBtn.removeAttribute('aria-disabled');
      if (_avail) { delete stickyBtn.dataset.soldout; } else { stickyBtn.dataset.soldout = 'true'; }
      var _slbl = stickyBtn.querySelector('.satc-label') || stickyBtn;
      _slbl.textContent = _avail ? 'In den Warenkorb' : 'Benachrichtigen';
    }
    if (priceEl) priceEl.textContent = cpMoney(cpSel.price);
    var _cupC = (cpSel.cup && cpSel.cup > 0) ? cpSel.cup : 0;
    if (proTasseEl) { var _ppc = proTasseEl.closest('.hero-protasse'); if (_cupC > 0) { proTasseEl.textContent = cpMoney(_cupC); if (_ppc) _ppc.style.display=''; } else if (_ppc) { _ppc.style.display='none'; } }
    if (statProTasseEl) { var _sit = statProTasseEl.closest('.stat-item'); if (_cupC > 0) { statProTasseEl.textContent = cpMoney(_cupC); if (_sit) _sit.style.display=''; } else if (_sit) { _sit.style.display='none'; } }
    if (stickyPriceEl) stickyPriceEl.textContent = cpMoney(cpSel.price);
    var _cmp = cpSel.compare; var _pct = (_cmp && _cmp > cpSel.price) ? Math.round((_cmp - cpSel.price) * 100 / _cmp) : 0;
    var _aktEl = scope.querySelector('#heroAktion');
    var _saveTxt = _aktEl ? ('\u2212' + cpMoney(_cmp - cpSel.price)) : ('\u2212' + _pct + '\u00a0%');
    if (_pct > 0) {
      if (heroWasEl){ heroWasEl.hidden = false; heroWasEl.textContent = cpMoney(_cmp); }
      if (heroBadgeEl && !cbRetter){ heroBadgeEl.hidden = false; heroBadgeEl.innerHTML = _saveTxt; }
      if (stickyWasEl){ stickyWasEl.hidden = false; stickyWasEl.textContent = cpMoney(_cmp); }
      if (stickySaveEl && !cbRetter){ stickySaveEl.hidden = false; stickySaveEl.innerHTML = '\u2212' + _pct + '\u00a0%'; }
    } else {
      [heroWasEl, heroBadgeEl, stickyWasEl, stickySaveEl].forEach(function(e){ if(e){ e.hidden = true; e.textContent = ''; } });
    }
    if (_aktEl) _aktEl.classList.toggle('is-sale', _pct > 0);
    var _txtEl = scope.querySelector('#heroAktionText');
    if (_txtEl) { var _t = (_pct > 0 && _txtEl.dataset.sale) ? _txtEl.dataset.sale : _txtEl.dataset.default; if (_t != null && _t !== '') _txtEl.textContent = _t; }
    if (priceNoteEl) priceNoteEl.textContent = cpSel.title;
    var _gpEl = scope.querySelector('#heroGrundpreis'); if (_gpEl){ _gpEl.textContent = cpSel.gp || ''; _gpEl.hidden = !(cpSel.gp && cpSel.gp.length); }
    var _pn = scope.querySelector('#heroPackNote');
    if (_pn) {
      var _baseG = 0;
      cpVariants.forEach(function(v){ if (v.g > 0 && (_baseG === 0 || v.g < _baseG)) _baseG = v.g; });
      var _pkn = (_baseG > 0 && cpSel.g > 0) ? Math.round(cpSel.g / _baseG) : 1;
      if (_pkn >= 2) {
        _pn.textContent = _pkn + ' einzeln verpackte ' + (_pn.dataset.nounPl || 'Beutel') + ' à ' + (_pn.dataset.baseLabel || '') + (_pn.dataset.fresh === '0' ? '' : ' — bleibt so länger frisch.');
        _pn.classList.remove('is-empty');
      } else { _pn.innerHTML = '&nbsp;'; _pn.classList.add('is-empty'); }
    }
    var _ls = scope.querySelector('#heroLowstock');
    if (_ls) {
      var _q = (typeof cpSel.q === 'number') ? cpSel.q : 999;
      if (cpSel.available !== false && _q > 0 && _q <= 10) {
        var _lsn = _ls.querySelector('#heroLowstockN'); if (_lsn) _lsn.textContent = _q;
        _ls.hidden = false;
      } else { _ls.hidden = true; }
    }
    scope.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(i => i.value = cpSel.id);
    if (skuEl) skuEl.textContent = (cpSel.sku && String(cpSel.sku).length) ? cpSel.sku : '—';
    if (b2bEl){
      var _t = b2bEl.dataset.title || '';
      var _u = b2bEl.dataset.url || '';
      var _sku = cpSel.sku || '';
      var _body = 'Produkt: ' + _t + '\nArt.-Nr.: ' + _sku + '\nProduktlink: ' + _u + '\n\nIch interessiere mich als Geschäftskunde für dieses Produkt und bitte um ein Angebot.\n\nGewünschte Menge (bitte ausfüllen): ';
      b2bEl.href = 'mailto:b2b@cellini-shop.de?subject=' + encodeURIComponent('B2B-Anfrage: ' + _t) + '&body=' + encodeURIComponent(_body);
    }
    scope.querySelectorAll('.hero-var-opt, .sticky-var-opt').forEach(function(b){ b.classList.toggle('active', String(b.dataset.vid) === String(cpSel.id)); });
    try { const u = new URL(window.location.href); u.searchParams.set('variant', cpSel.id); history.replaceState({}, '', u); } catch(e){}
  }
  /* CS-516: Prozent-Badge in der Appstle-Abo-Option — Abo-Preis ggü. aktuellem Einzelpack-Preis × Menge („ggü. 1 kg Einzelpack“), abgerundet (ab 1 % ganze Zahl, darunter eine Nachkommastelle) — jede Variante mit Abo-Plan; Abo teurer als Einzelpacks → kein Badge (Julian 01.10.).
     Nur CSS-Variable am Section-Element + ::after im Widget — KEIN Eingriff in den Appstle-DOM (Appstle rendert bei DOM-Änderungen neu → Endlosschleife). */
  function cpAboBadge(){
    if (!cpSel) return;
    /* Menge aus dem Grundpreis-Feld (unit_price_measurement.quantity_value, PAngV-gepflegt, 05 §4); Gewicht nur als Rückfall */
    var _useQ = cpVariants.every(function(v){ return !v.abo || (v.qv > 0); }) && cpSel.qv > 0;
    var _m = function(v){ return _useQ ? (parseFloat(v.qv) || 0) : (v.g || 0); };
    var _base = null;
    cpVariants.forEach(function(v){ if (_m(v) > 0 && (!_base || _m(v) < _m(_base))) _base = v; });
    var _n = (_base && _m(cpSel) > 0) ? Math.round(_m(cpSel) / _m(_base)) : 1;
    if (!_base || _n < 1) { _base = cpSel; _n = 1; }
    var _ref = _base.price * _n;
    var _r = (cpSel.abo && _ref > cpSel.abo) ? (_ref - cpSel.abo) * 100 / _ref : 0;
    var _p = _r >= 1 ? String(Math.floor(_r)) : String(Math.floor(_r * 10) / 10).replace('.', ',');
    var _lbl = String(_base.title || '').toLowerCase().replace(/(^|\s)([a-zäöü])/g, function(m, sp, c){ return sp + c.toUpperCase(); }).replace(/\b(Kg|G|Ml|L)\b/g, function(u){ return u.toLowerCase(); }).replace(/ /g, '\u00a0');
    if (_r > 0 && _p !== '0') {
      scope.style.setProperty('--cp-abo-save', '"\u2212' + _p + '\u00a0%"');
      scope.style.setProperty('--cp-abo-ref', '"gg\u00fc.\u00a0' + _lbl + '\u00a0Einzelpack"');
    } else { scope.style.removeProperty('--cp-abo-save'); scope.style.removeProperty('--cp-abo-ref'); }
    /* CS-703: Appstle zeigt in der Abo-Option den Einmalpreis der Variante als Streichpreis. Nur zeigen, wenn er über dem Abo-Preis liegt;
       im Sale (compare > price) Hinweis mit dem Abo-Preis. Abo-Festpreis bleibt in Aktionen (JH 23.10.2026, 19 §2c). */
    var _abo = cpSel.abo ? Number(cpSel.abo) : 0;
    scope.classList.toggle('cp-abo-nostrike', !!_abo && !(Number(cpSel.price) > _abo));
    var _sale = !!(_abo && cpSel.compare && Number(cpSel.compare) > Number(cpSel.price));
    if (_sale) {
      var _eur = (_abo / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      scope.style.setProperty('--cp-abo-hint-b', '"Aktionspreis gilt f\u00fcr den Einzelkauf."');
      scope.style.setProperty('--cp-abo-hint', '" Im Abo bleibt es bei ' + _eur + ' je Lieferung."');
    } else { scope.style.removeProperty('--cp-abo-hint-b'); scope.style.removeProperty('--cp-abo-hint'); }
    scope.classList.toggle('cp-abo-salehint', _sale);
  }
  cpAboBadge();
  /* CS-711 v1.34.5 (INP): Beim Klick nur das sofort sichtbare Feedback (aktive Pille) synchron setzen.
     Alles andere läuft nach dem nächsten Paint: Preis-Render, Formular-ID (löst das Neu-Rendern des Appstle-Abo-Widgets aus,
     gemessen 30–300 ms je Variante), cpAboBadge und history.replaceState (von Tracking-Skripten umhüllt, ~30 ms).
     Mehrfachklicks: es rendert immer der zuletzt gewählte cpSel, ein Lauf pro Frame.
     Sicherheitsnetz: Wird das Formular vor dem verzögerten Render abgeschickt, wird vorher synchron gerendert. */
  let cpRenderQueued = false;
  function cpRenderNow(){ if (!cpRenderQueued) return; cpRenderQueued = false; cpRender(); cpAboBadge(); }
  function cpRenderAfterPaint(){
    if (cpRenderQueued) return;
    cpRenderQueued = true;
    requestAnimationFrame(function(){ setTimeout(cpRenderNow, 0); });
  }
  window.addEventListener('submit', cpRenderNow, true); /* window-Capture: läuft vor dem Warenkorb-Submit-Handler (document-Capture mit stopImmediatePropagation) */
  function cpSelectQuick(v){
    cpSel = v;
    scope.querySelectorAll('.hero-var-opt, .sticky-var-opt').forEach(function(b){ b.classList.toggle('active', String(b.dataset.vid) === String(v.id)); });
    cpRenderAfterPaint();
  }
  scope.querySelectorAll('.hero-var-opt').forEach(btn => {
    btn.addEventListener('click', () => {
      const v = cpVariants.find(x => String(x.id) === btn.dataset.vid);
      if (!v) return;
      cpSelectQuick(v);
    });
  });
  scope.querySelectorAll('.sticky-var-opt').forEach(btn => {
    btn.addEventListener('click', () => {
      const v = cpVariants.find(x => String(x.id) === btn.dataset.vid);
      if (!v) return;
      cpSelectQuick(v);
    });
  });
  /* Sticky-Button: bei Ausverkauft Back-in-Stock-Modal statt Warenkorb */
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function (e) {
      if (stickyBtn.dataset.soldout === 'true' && window.CelliniBIS && cpSel) {
        e.preventDefault();
        window.CelliniBIS.open(cpSel.id, stickyBtn.getAttribute('data-notify-title'));
      }
    });
  }
  subOpts.forEach(btn => {
    btn.addEventListener('click', () => {
      subOpts.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      cpRenderAfterPaint();
    });
  });
  cpRender();

  /* ── SUBNAV ACTIVE ───────────────────────────────── */
  const navLinks = scope.querySelectorAll('.subnav a');
  const sectionIds = ['profil','geschichte','herkunft','zubereitung','heritage','empfohlen','bewertungen'];
  new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        navLinks.forEach(a => a.classList.remove('active'));
        const link = scope.querySelector(`.subnav a[href="#${e.target.id}"]`);
        if (link) link.classList.add('active');
      }
    });
  }, { rootMargin:'-30% 0px -60% 0px' })
  .observe && sectionIds.forEach(id => {
    const el = document.getElementById(id);
    if (el) new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        navLinks.forEach(a => a.classList.remove('active'));
        const link = scope.querySelector(`.subnav a[href="#${id}"]`);
        if (link) link.classList.add('active');
      }
    }, { rootMargin:'-30% 0px -60% 0px' }).observe(el);
  });

  /* ── SCROLL REVEAL ───────────────────────────────── */
  const revObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); revObs.unobserve(e.target); } });
  }, { threshold:.12 });
  scope.querySelectorAll('.reveal,.reveal-left,.reveal-right,.reveal-scale').forEach(el => revObs.observe(el));

  /* ── COUNTER ANIMATION ───────────────────────────── */
  function animCount(el, target, dur) {
    dur = dur || 900; let start = null;
    const step = ts => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round(p * target);
      if (p < 1) requestAnimationFrame(step); else el.textContent = target;
    };
    requestAnimationFrame(step);
  }
  new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const target = +e.target.dataset.countTarget;
        const numEl = e.target.querySelector('.count-num');
        if (numEl) animCount(numEl, target);
        e.target.classList.add('visible');
      }
    });
  }, { threshold:.3 }).observe && scope.querySelectorAll('[data-count-target]').forEach(el => {
    new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        const t = +entries[0].target.dataset.countTarget;
        const n = entries[0].target.querySelector('.count-num');
        if (n) animCount(n, t);
        entries[0].target.classList.add('visible');
      }
    }, { threshold:.3 }).observe(el);
  });

  /* ── B/A SLIDER ──────────────────────────────────── */
  const baCont = scope.querySelector('#baContainer');
  const baRight = scope.querySelector('#baRight');
  const baDivider = scope.querySelector('#baDivider');
  const baHandle = scope.querySelector('#baHandle');
  if (baCont && baRight && baDivider && baHandle) {
    let baActive = false;
    function setBA(pct) {
      pct = Math.max(5, Math.min(95, pct));
      baRight.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      baDivider.style.left = pct + '%';
      baHandle.style.left = pct + '%';
    }
    setBA(50);
    baCont.addEventListener('mousedown', () => baActive = true);
    window.addEventListener('mouseup', () => baActive = false);
    baCont.addEventListener('mousemove', e => {
      if (!baActive) return;
      setBA((e.clientX - baCont.getBoundingClientRect().left) / baCont.offsetWidth * 100);
    });
    /* Mobil: vertikales Wischen scrollt die Seite weiter, nur waagerechtes Ziehen bewegt den Regler */
    let baX0 = 0, baY0 = 0, baLock = '';
    baCont.addEventListener('touchstart', e => { const t = e.touches[0]; baX0 = t.clientX; baY0 = t.clientY; baLock = ''; baActive = true; }, { passive:true });
    baCont.addEventListener('touchend', () => { baActive = false; baLock = ''; });
    baCont.addEventListener('touchmove', e => {
      if (!baActive) return;
      const t = e.touches[0];
      if (!baLock) { const dx = Math.abs(t.clientX - baX0), dy = Math.abs(t.clientY - baY0); if (dx < 6 && dy < 6) return; baLock = dx > dy ? 'x' : 'y'; }
      if (baLock !== 'x') { baActive = false; return; }
      setBA((t.clientX - baCont.getBoundingClientRect().left) / baCont.offsetWidth * 100);
      e.preventDefault();
    }, { passive:false });
    new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        let p = 50, dir = 1, frames = 0;
        const swing = () => { if (frames > 60) return; p += dir * 0.6; if (p > 68) dir = -1; if (p < 32) dir = 1; setBA(p); frames++; requestAnimationFrame(swing); };
        requestAnimationFrame(swing);
      }
    }, { threshold:.5 }).observe(baCont);
  }

  /* ── PARALLAX HERKUNFT ───────────────────────────── */
  const herEl = scope.querySelector('#herkunftParallax');
  if (herEl) {
    window.addEventListener('scroll', () => {
      const r = herEl.getBoundingClientRect();
      if (r.top > window.innerHeight || r.bottom < 0) return;
      herEl.style.transform = `translateY(${(r.top / window.innerHeight) * 25}px)`;
    }, { passive:true });
  }

  /* ── PREP SPECS STAGGER ──────────────────────────── */
  const prepBar = scope.querySelector('#prepSpecsBar');
  if (prepBar) {
    new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        scope.querySelectorAll('.prep-spec').forEach(el => {
          setTimeout(() => el.classList.add('visible'), +el.dataset.delay || 0);
        });
      }
    }, { threshold:.4 }).observe(prepBar);
  }

  /* ── HERITAGE SCROLL ─────────────────────────────── */
  const heritageWrapper = scope.querySelector('#heritageWrapper');
  const heritageHscroll = scope.querySelector('#heritageHscroll');
  const dots = scope.querySelectorAll('.heritage-dot');
  const hFill = scope.querySelector('#heritageProgressFill');
  if (heritageWrapper && window.innerWidth > 800) {
    window.addEventListener('scroll', () => {
      const rect = heritageWrapper.getBoundingClientRect();
      const scrolled = -rect.top;
      if (scrolled < 0 || scrolled > heritageWrapper.offsetHeight - window.innerHeight) return;
      const pct = scrolled / (heritageWrapper.offsetHeight - window.innerHeight);
      heritageHscroll.style.transform = `translateX(-${pct * window.innerWidth * 2}px)`;
      const activePanel = Math.min(2, Math.round(pct * 2));
      dots.forEach((d, i) => d.classList.toggle('active', i === activePanel));
      if (hFill) hFill.style.width = (pct * 100) + '%';
    }, { passive:true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cellini-kaffee-story"]) return;
  try {
    
(function(){
  // FAQ Accordion + Scroll-Reveal (beide cellini-plp Wrapper auf der Seite)
  document.querySelectorAll('.cellini-plp .faq-item__question').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      var ans = item.querySelector('.faq-item__answer');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (ans) {
        if (open) {
          ans.style.setProperty('max-height', 'none', 'important');
          ans.style.setProperty('overflow', 'visible', 'important');
          ans.style.setProperty('padding-bottom', '24px', 'important');
        } else {
          ans.style.removeProperty('max-height');
          ans.style.removeProperty('overflow');
          ans.style.removeProperty('padding-bottom');
        }
      }
    });
  });
  var anims = document.querySelectorAll('.cellini-plp .anim, .cellini-plp .anim-left, .cellini-plp .anim-right');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target);} }); }, {threshold:0.12});
    anims.forEach(function(el){ io.observe(el); });
  } else { anims.forEach(function(el){ el.classList.add('is-visible'); }); }

  // eTrusted: per-SKU AggregateRating aus dem CollectionPage-Schema (kein Grid-DOM noetig)
  var schemaEl = document.querySelector('#plp-collection-schema');
  if(!schemaEl) return;
  var schema; try{ schema = JSON.parse(schemaEl.textContent); }catch(e){ return; }
  var CHL='chl-5e1eb0ff-dd80-45ce-9b1c-b3283f08c949';
  function hex(s){ return Array.from(String(s)).map(function(c){return c.charCodeAt(0).toString(16).padStart(2,'0');}).join(''); }
  var cp=(schema['@graph']||[]).filter(function(n){return n['@type']==='CollectionPage';})[0];
  if(!cp || !cp.mainEntity || !cp.mainEntity.itemListElement) return;
  var items=cp.mainEntity.itemListElement;
  Promise.all(items.map(function(li){
    var p=li.item; if(!p || !p.sku) return Promise.resolve();
    var url='https://integrations.etrusted.com/feeds/grades/v1/channels/'+CHL+'/products/sku/'+hex(p.sku)+'/feed.json';
    return fetch(url).then(function(r){return r.ok?r.json():null;}).then(function(j){
      var g=j&&j.grades&&j.grades.overall;
      if(g&&g.count>0){ p.aggregateRating={'@type':'AggregateRating',ratingValue:(Math.round(g.rating*100)/100).toFixed(2),reviewCount:String(g.count),bestRating:'5',worstRating:'1'}; }
    }).catch(function(){});
  })).then(function(){ try{ schemaEl.textContent = JSON.stringify(schema); }catch(e){} });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
